<div class="system-server-container">
    <!--system status-->
    <div class="header-container">
        <span class="h3-regular header-title">{{ 'general.system_config'|stringLiterals}}</span>
        <div class="button-container">
            <button tam-button tamType="primary" tamSize="normal" class="submit-button"
                (click)="clickSystemStatusShut()"
                [disabled]="false">{{'system.shut_down_this_computer'|stringLiterals}}</button>
            <button tam-button tamType="primary" tamSize="normal" class="submit-button"
                (click)="clickSystemStatusReboot()"
                [disabled]="false">{{'system.reboot_this_computer'|stringLiterals}}</button>
        </div>
    </div>

    <!--System Config-->
    <form [formGroup]="systemConfigForm">
        <!--Session Control Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.session_control_parameters' | stringLiterals}} </label>
            </div>
            <!--webClientTimeoutMinutes-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': webClientTimeoutMinutes.invalid}">
                <div>
                    <label class="label-2">{{'system.web_client_session_timeout' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="webClientTimeoutMinutes"
                    tid="webClientTimeoutMinutes" />
                <div class="tam-form-help error-tip"
                    *ngIf="webClientTimeoutMinutes.invalid && webClientTimeoutMinutes.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="webClientTimeoutMinutes.invalid && webClientTimeoutMinutes.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="webClientTimeoutMinutes.invalid && webClientTimeoutMinutes.errors['minVaild']">
                    {{'general.minimum_is_10' | stringLiterals}}
                </div>
            </div>
            <!--richClientTimeoutMinutes -->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': richClientTimeoutMinutes.invalid}">
                <div>
                    <label class="label-2">{{'system.rich_client_session_timeout' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="richClientTimeoutMinutes"
                    formControlName="richClientTimeoutMinutes" />
                <div class="tam-form-help error-tip"
                    *ngIf="richClientTimeoutMinutes.invalid && richClientTimeoutMinutes.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="richClientTimeoutMinutes.invalid && richClientTimeoutMinutes.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="richClientTimeoutMinutes.invalid && richClientTimeoutMinutes.errors['minVaild']">
                    {{'general.minimum_is_10' | stringLiterals}}
                </div>
            </div>
        </div>
        <!--Message Queue Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.message_queue_parameters' | stringLiterals}} </label>
            </div>
            <!--openWireHost-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': openWireHost.invalid}">
                <div>
                    <label class="label-2">{{'system.activeMQ_host' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="openWireHost"
                    tid="openWireHost" />
            </div>
            <!--openWirePort-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': openWirePort.invalid}">
                <div>
                    <label class="label-2">{{'system.port_integer_minimum_1024' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="openWirePort"
                    tid="openWirePort" />
                <div class="tam-form-help error-tip" *ngIf="openWirePort.invalid && openWirePort.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="openWirePort.invalid && openWirePort.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip" *ngIf="openWirePort.invalid && openWirePort.errors['portVaild']">
                    {{'general.invalid_smtp_port_address_message' | stringLiterals}}
                </div>
            </div>
            <!--subscription stomp protocol-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': stompPort.invalid}">
                <div>
                    <label class="label-2">{{'system.stomp_protocol_integer_minimum_1024' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="stompPort"
                    tid="stompPort" />
                <div class="tam-form-help error-tip" *ngIf="stompPort.invalid && stompPort.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip" *ngIf="stompPort.invalid && stompPort.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip" *ngIf="stompPort.invalid && stompPort.errors['portVaild']">
                    {{'general.invaild_subscription_stomp_protocol' | stringLiterals}}
                </div>
            </div>
        </div>
        <!--Web Socket Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.web_socket_parameters' | stringLiterals}} </label>
            </div>
            <!--webSocketPort-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': webSocketPort.invalid}">
                <div>
                    <label class="label-2">{{'system.port_integer_minimum_1024' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="webSocketPort"
                    tid="webSocketPort" />
                <div class="tam-form-help error-tip" *ngIf="webSocketPort.invalid && webSocketPort.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="webSocketPort.invalid && webSocketPort.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip" *ngIf="webSocketPort.invalid && webSocketPort.errors['portVaild']">
                    {{'general.invalid_smtp_port_address_message' | stringLiterals}}
                </div>
            </div>
            <!--webSocketProtocol-->
            <div>
                <label class="label-2">{{'system.protocol_type' | stringLiterals}}</label>
                <div>
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" formControlName="webSocketProtocol"
                        tid="webSocketProtocol" [data]="protocol_types" (selectionChange)="clickVaild()">
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>
        <!--Tamale Web Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.tamale_web_parameters' | stringLiterals}} </label>
            </div>
            <!--tokenInvalidInterval-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': tokenInvalidInterval.invalid}">
                <div>
                    <label class="label-2">{{'system.tamale_web_token_expiration_time' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="tokenInvalidInterval"
                    tid="tokenInvalidInterval" />
                <div class="tam-form-help error-tip"
                    *ngIf="tokenInvalidInterval.invalid && tokenInvalidInterval.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="tokenInvalidInterval.invalid && tokenInvalidInterval.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="tokenInvalidInterval.invalid && tokenInvalidInterval.errors['minVaild']">
                    {{'general.minimum_is_10' | stringLiterals}}
                </div>
            </div>
            <!--tokenPluginInvalidInterval-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': tokenPluginInvalidInterval.invalid}">
                <div>
                    <label class="label-2">{{'system.tokenExpiration_time' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="tokenPluginInvalidInterval"
                    formControlName="tokenPluginInvalidInterval" />
                <div class="tam-form-help error-tip"
                    *ngIf="tokenPluginInvalidInterval.invalid && tokenPluginInvalidInterval.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="tokenPluginInvalidInterval.invalid && tokenPluginInvalidInterval.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="tokenPluginInvalidInterval.invalid && tokenPluginInvalidInterval.errors['minVaild']">
                    {{'general.minimum_is_10' | stringLiterals}}
                </div>
            </div>
            <!--tamaleProxyURL-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': tamaleProxyURL.invalid}">
                <div>
                    <label class="label-2">{{'system.tamale_proxy_url' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="tamaleProxyURL"
                    tid="tamaleProxyURL" />
            </div>
        </div>
        <!--Tamale Mobile Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.tamale_mobile_parameters' | stringLiterals}} </label>
            </div>
            <!--tokenMobileInvalidInterval-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': tokenMobileInvalidInterval.invalid}">
                <div>
                    <label class="label-2">{{'system.tamale_mobile_tokenExpiration_time' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="tokenMobileInvalidInterval"
                    formControlName="tokenMobileInvalidInterval" />
                <div class="tam-form-help error-tip"
                    *ngIf="tokenMobileInvalidInterval.invalid && tokenMobileInvalidInterval.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="tokenMobileInvalidInterval.invalid && tokenMobileInvalidInterval.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="tokenMobileInvalidInterval.invalid && tokenMobileInvalidInterval.errors['minVaild']">
                    {{'general.minimum_is_10' | stringLiterals}}
                </div>
            </div>
        </div>
        <!--Tamale SSO Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.tamale_sso_parameters' | stringLiterals}} </label>
            </div>
            <div>
                <label class="label-2">{{'system.open_sso_for_tamale' | stringLiterals}}</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off" formControlName="enableSSO" tid="enableSSO"
                        (valueChange)="clickVaild()">
                    </kendo-switch>
                </div>
            </div>
            <div class="tam-form-field input-setting msg"
                [ngClass]="{'has-error': tamaleIdpURL.invalid || proxyTamaleIdpURL.invalid}">
                <div class="tam-form-help error-tip"
                    *ngIf="enableSSO.value && (tamaleIdpURL.invalid && tamaleIdpURL.errors['required']) && (proxyTamaleIdpURL.invalid && proxyTamaleIdpURL.errors['required']) ">
                    {{'system.msg' | stringLiterals}}
                </div>
            </div>
            <!--tamaleIdpURL-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': tamaleIdpURL.invalid}">
                <div>
                    <label class="label-2">{{'system.tamale_idp_url' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="tamaleIdpURL"
                    tid="tamaleIdpURL" />
                <div class="tam-form-help error-tip" *ngIf="tamaleIdpURL.invalid && tamaleIdpURL.errors['urlVaild']">
                    {{'general.invalid_url_message' | stringLiterals}}
                </div>
            </div>
            <!--proxyTamaleIdpURL-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': proxyTamaleIdpURL.invalid}">
                <div>
                    <label class="label-2">{{'system.proxy_tamale_idp_url' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="proxyTamaleIdpURL"
                    tid="proxyTamaleIdpURL" />
                <div class="tam-form-help error-tip"
                    *ngIf="proxyTamaleIdpURL.invalid && proxyTamaleIdpURL.errors['urlVaild']">
                    {{'general.invalid_url_message' | stringLiterals}}
                </div>
            </div>
            <!--tamaleIdpHomeURL-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': tamaleIdpHomeURL.invalid}">
                <div>
                    <label class="label-2">{{'system.tamale_idp_home_url' | stringLiterals}}<span
                            *ngIf="this.enableSSO.value" class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="tamaleIdpHomeURL"
                    tid="tamaleIdpHomeURL" />
                <div class="tam-form-help error-tip"
                    *ngIf="tamaleIdpHomeURL.invalid && tamaleIdpHomeURL.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="tamaleIdpHomeURL.invalid && tamaleIdpHomeURL.errors['urlVaild']">
                    {{'general.invalid_url_message' | stringLiterals}}
                </div>
            </div>
            <!--identityProviderIssuer-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': identityProviderIssuer.invalid}">
                <div>
                    <label class="label-2">{{'system.rms_identity_provider_issuer' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="identityProviderIssuer"
                    tid="identityProviderIssuer" />
                <div class="tam-form-help error-tip"
                    *ngIf="identityProviderIssuer.invalid && identityProviderIssuer.errors['urlVaild']">
                    {{'general.invalid_url_message' | stringLiterals}}
                </div>
            </div>
            <!--certificate-->
            <div>
                <label class="label-2">{{'system.rms_identity_provider_x509_certificate' | stringLiterals}}</label>
            </div>
            <textarea formControlName="certificate" class="description-container" (blur)="clickVaild()"
                tid="certificate"></textarea>
            <!--proxyIdentityProviderIssuer-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': proxyIdentityProviderIssuer.invalid}">
                <div>
                    <label class="label-2">{{'system.proxy_identity_provider_issuer' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="proxyIdentityProviderIssuer"
                    formControlName="proxyIdentityProviderIssuer" />
            </div>
            <!--proxyCertificate-->
            <div>
                <label class="label-2">{{'system.proxy_identity_provider_x509_certificate' | stringLiterals}}</label>
            </div>
            <textarea formControlName="proxyCertificate" (blur)="clickVaild()" class="description-container"
                tid="proxyCertificate"></textarea>
        </div>
        <!--Client System Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.client_system_parameters' | stringLiterals}} </label>
            </div>
            <!--contentDeletionWindow-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': contentDeletionWindow.invalid}">
                <div>
                    <label class="label-2">{{'system.content_deletion_window' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="contentDeletionWindow"
                    tid="contentDeletionWindow" />
                <div class="tam-form-help error-tip"
                    *ngIf="contentDeletionWindow.invalid && contentDeletionWindow.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--noteDeletionWindow-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': noteDeletionWindow.invalid}">
                <div>
                    <label class="label-2">{{'system.note_deletion_window' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="noteDeletionWindow"
                    tid="noteDeletionWindow" />
                <div class="tam-form-help error-tip"
                    *ngIf="noteDeletionWindow.invalid && noteDeletionWindow.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--commentDeletionWindow-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': commentDeletionWindow.invalid}">
                <div>
                    <label class="label-2">{{'system.comment_deletion_window' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="commentDeletionWindow"
                    tid="commentDeletionWindow" />
                <div class="tam-form-help error-tip"
                    *ngIf="commentDeletionWindow.invalid && commentDeletionWindow.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--filePurgeProtectionWindow-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': filePurgeProtectionWindow.invalid}">
                <div>
                    <label class="label-2">{{'system.file_purge_protection_window' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="filePurgeProtectionWindow"
                    formControlName="filePurgeProtectionWindow" />
                <div class="tam-form-help error-tip"
                    *ngIf="filePurgeProtectionWindow.invalid && filePurgeProtectionWindow.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--maxRange-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': maxRange.invalid}">
                <div>
                    <label class="label-2">{{'system.max_range' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="maxRange" tid="maxRange" />
                <div class="tam-form-help error-tip" *ngIf="maxRange.invalid && maxRange.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--blurbLength-->
            <div>
                <label class="label-2">{{'system.number_of_characters_in_blurb' | stringLiterals}}</label>
                <div>
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" formControlName="blurbLength"
                        tid="blurbLength" [data]="characters_numbers" (selectionChange)="clickVaild()">
                    </kendo-dropdownlist>
                </div>
            </div>

            <!--showGoToAssist-->
            <div>
                <label class="label-2">{{'system.show_go_to_assist_button' | stringLiterals}}</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off" (valueChange)="clickVaild()" tid="showGoToAssist"
                        formControlName="showGoToAssist"></kendo-switch>
                </div>
            </div>

            <!--clientPasswordManagement-->
            <div>
                <label class="label-2">{{'system.client_password_management' | stringLiterals}}</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off" (valueChange)="clickVaild()"
                        tid="clientPasswordManagement" formControlName="clientPasswordManagement"></kendo-switch>
                </div>
            </div>

            <!--autoLoginAllowed-->
            <div>
                <label class="label-2">{{'system.auto_logon_management' | stringLiterals}}</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off" (valueChange)="clickVaild()" tid="autoLoginAllowed"
                        formControlName="autoLoginAllowed"></kendo-switch>
                </div>
            </div>

            <!--showTamaleWebLink-->
            <div>
                <label class="label-2">{{'system.show_tamale_web_link_on_login' | stringLiterals}}</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off" (valueChange)="clickVaild()" tid="showTamaleWebLink"
                        formControlName="showTamaleWebLink"></kendo-switch>
                </div>
            </div>

            <!--showFullOffline-->
            <div>
                <label class="label-2">{{'system.show_full_offline' | stringLiterals}}</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off" (valueChange)="clickVaild()" tid="showFullOffline"
                        formControlName="showFullOffline"></kendo-switch>
                </div>
            </div>

            <!--TSSTickerFormatTypeOverride-->
            <div>
                <label class="label-2">{{'system.default_ticker_format' | stringLiterals}}</label>
                <div>
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" tid="tssTickerFormatTypeOverride"
                        formControlName="tssTickerFormatTypeOverride" [data]="ticker_Formats"
                        (selectionChange)="clickVaild()">
                    </kendo-dropdownlist>
                </div>
            </div>

            <!--TSSRegionTypeOverride-->
            <div>
                <label class="label-2">{{'system.default_preferred_region' | stringLiterals}}</label>
                <div>
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" tid="tssRegionTypeOverride"
                        formControlName="tssRegionTypeOverride" [data]="preferred_Regions"
                        (selectionChange)="clickVaild()">
                    </kendo-dropdownlist>
                </div>
            </div>

            <!--shortNameFormat-->
            <div>
                <label class="label-2">{{'system.shortname_format' | stringLiterals}}</label>
                <div>
                    <kendo-dropdownlist [popupSettings]="{appendTo: 'component'}" formControlName="shortNameFormat"
                        tid="shortNameFormat" [data]="shortname_Formats" (selectionChange)="clickVaild()">
                    </kendo-dropdownlist>
                </div>
            </div>
        </div>

        <!--Server Cache Config Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.server_cache_config_parameters' | stringLiterals}} </label>
            </div>

            <!--notificationRefreshMaxSize-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': notificationRefreshMaxSize.invalid}">
                <div>
                    <label class="label-2">{{'system.max_notification_refresh_size' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="notificationRefreshMaxSize"
                    formControlName="notificationRefreshMaxSize" />

                <div class="tam-form-help error-tip"
                    *ngIf="notificationRefreshMaxSize.invalid && notificationRefreshMaxSize.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--notificationRefreshMessageSize-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': notificationRefreshMessageSize.invalid}">
                <div>
                    <label class="label-2">{{'system.notification_refresh_message_size' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>

                <input (blur)="clickVaild()" class="tam-input system-input" tid="notificationRefreshMessageSize"
                    formControlName="notificationRefreshMessageSize" />

                <div class="tam-form-help error-tip"
                    *ngIf="notificationRefreshMessageSize.invalid && notificationRefreshMessageSize.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>

            <!--maxContentCacheSize-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': maxContentCacheSize.invalid}">
                <div>
                    <label class="label-2">{{'system.max_content_cache_size' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="maxContentCacheSize"
                    tid="maxContentCacheSize" />
                <div class="tam-form-help error-tip"
                    *ngIf="maxContentCacheSize.invalid && maxContentCacheSize.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
        </div>

        <!--Search Config Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.search_config_parameters' | stringLiterals}} </label>
            </div>
            <!--maxSearchHits-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': maxSearchHits.invalid}">
                <div>
                    <label class="label-2">{{'system.max_search_hits' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="maxSearchHits"
                    tid="maxSearchHits" />
                <div class="tam-form-help error-tip" *ngIf="maxSearchHits.invalid && maxSearchHits.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
                <div class="tam-form-help error-tip"
                    *ngIf="maxSearchHits.invalid && maxSearchHits.errors['integerVaild']">
                    {{'general.invalid_integer_number_message' | stringLiterals}}
                </div>
            </div>

            <!--maxClauseCount-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': maxClauseCount.invalid}">
                <div>
                    <label class="label-2">{{'system.max_clause_count' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="maxClauseCount"
                    tid="maxClauseCount" />
                <div class="tam-form-help error-tip"
                    *ngIf="maxClauseCount.invalid && maxClauseCount.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>

            <div>
                <label class="label-2">{{'system.sort_results_by_date' | stringLiterals}}</label>
                <div>
                    <kendo-switch onLabel="On" offLabel="Off" formControlName="sortResultsByDate"
                        tid="sortResultsByDate" (valueChange)="clickVaild()"></kendo-switch>
                </div>
            </div>
        </div>

        <!--Notification Deletion Windows-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.notification_deletion_windows' | stringLiterals}} </label>
            </div>

            <!--newsNotificationDeletionWindow-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': newsNotificationDeletionWindow.invalid}">
                <div>
                    <label class="label-2">{{'system.news_notification_deletion_window' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="newsNotificationDeletionWindow"
                    formControlName="newsNotificationDeletionWindow" />

                <div class="tam-form-help error-tip"
                    *ngIf="newsNotificationDeletionWindow.invalid && newsNotificationDeletionWindow.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--noteNotificationDeletionWindow-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': noteNotificationDeletionWindow.invalid}">
                <div>
                    <label class="label-2">{{'system.note_notification_deletion_window' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>

                <input (blur)="clickVaild()" class="tam-input system-input" tid="noteNotificationDeletionWindow"
                    formControlName="noteNotificationDeletionWindow" />

                <div class="tam-form-help error-tip"
                    *ngIf="noteNotificationDeletionWindow.invalid && noteNotificationDeletionWindow.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>

            <!--blastEmailNotificationDeletionWindow-->
            <div class="tam-form-field input-setting"
                [ngClass]="{'has-error': blastEmailNotificationDeletionWindow.invalid}">
                <div>
                    <label class="label-2">{{'system.research_email_notification_deletion_window' |
                        stringLiterals}}<span class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="blastEmailNotificationDeletionWindow"
                    formControlName="blastEmailNotificationDeletionWindow" />
                <div class="tam-form-help error-tip"
                    *ngIf="blastEmailNotificationDeletionWindow.invalid && blastEmailNotificationDeletionWindow.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
            <!--maxNotificationCacheFileSize-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': maxNotificationCacheFileSize.invalid}">
                <div>
                    <label class="label-2">{{'system.max_notification_cache_file_size' | stringLiterals}}<span
                            class="required-field">&nbsp;*</span></label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" tid="maxNotificationCacheFileSize"
                    formControlName="maxNotificationCacheFileSize" />
                <div class="tam-form-help error-tip"
                    *ngIf="maxNotificationCacheFileSize.invalid && maxNotificationCacheFileSize.errors['required']">
                    {{'general.required_error_message' | stringLiterals}}
                </div>
            </div>
        </div>

        <!--Nagios Config Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.nagios_config_parameters' | stringLiterals}} </label>
            </div>
            <!--nagiosHostname-->
            <div class="tam-form-field input-setting">
                <div>
                    <label class="label-2">{{'system.this_server_nagios_hostname' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="nagiosHostname"
                    tid="nagiosHostname" />
            </div>
            <!--nagiosCmdFile-->
            <div class="tam-form-field input-setting">
                <div>
                    <label class="label-2">{{'system.nagios_command_file_path' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="nagiosCmdFile"
                    tid="nagiosCmdFile" />
            </div>
        </div>

        <!--Client Service Contact Config Parameters-->
        <div class="control-border">
            <div>
                <label class="label-1">{{'system.client_service_contact_config_parameters' | stringLiterals}}
                </label>
            </div>
            <!--primaryContactName-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': primaryContactName.invalid}">
                <div>
                    <label class="label-2">{{'system.primary_contact_name' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="primaryContactName"
                    tid="primaryContactName" />
            </div>
            <!--primaryContactEmail-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': primaryContactEmail.invalid}">
                <div>
                    <label class="label-2">{{'system.primary_contact_email' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="primaryContactEmail"
                    tid="primaryContactEmail" />
                <div class="tam-form-help error-tip"
                    *ngIf="primaryContactEmail.invalid && primaryContactEmail.errors['emailVaild']">
                    {{'general.invalid_email_address_message' | stringLiterals}}
                </div>
            </div>
            <!--primaryContactMobile-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': primaryContactMobile.invalid}">
                <div>
                    <label class="label-2">{{'system.primary_contact_mobile' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="primaryContactMobile"
                    tid="primaryContactMobile" />
            </div>
            <!--primaryContactDesk-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': primaryContactDesk.invalid}">
                <div>
                    <label class="label-2">{{'system.primary_contact_phone' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="primaryContactDesk"
                    tid="primaryContactDesk" />

            </div>
            <!--secondaryContactName-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': secondaryContactName.invalid}">
                <div>
                    <label class="label-2">{{'system.secondary_contact_name' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="secondaryContactName"
                    tid="secondaryContactName" />
            </div>
            <!--secondaryContactEmail-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': secondaryContactEmail.invalid}">
                <div>
                    <label class="label-2">{{'system.secondary_contact_email' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="secondaryContactEmail"
                    tid="secondaryContactEmail" />
                <div class="tam-form-help error-tip"
                    *ngIf="secondaryContactEmail.invalid && secondaryContactEmail.errors['emailVaild']">
                    {{'general.invalid_email_address_message' | stringLiterals}}
                </div>
            </div>
            <!--secondaryContactMobile-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': secondaryContactMobile.invalid}">
                <div>
                    <label class="label-2">{{'system.secondary_contact_mobile' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="secondaryContactMobile"
                    tid="secondaryContactMobile" />
            </div>
            <!--secondaryContactDesk-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': secondaryContactDesk.invalid}">
                <div>
                    <label class="label-2">{{'system.secondary_contact_phone' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="secondaryContactDesk"
                    tid="secondaryContactDesk" />

            </div>
            <!--generalPhone-->
            <div class="tam-form-field input-setting">
                <div>
                    <label class="label-2">{{'system.general_contact_phone' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="generalPhone"
                    tid="generalPhone" />
            </div>
            <!--generalEmail-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': generalEmail.invalid}">
                <div>
                    <label class="label-2">{{'system.general_contact_email' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="generalEmail"
                    tid="generalEmail" />
                <div class="tam-form-help error-tip" *ngIf="generalEmail.invalid && generalEmail.errors['emailVaild']">
                    {{'general.invalid_email_address_message' | stringLiterals}}
                </div>
            </div>
            <!--copyNumber-->
            <div class="tam-form-field input-setting" [ngClass]="{'has-error': copyNumber.invalid}">
                <div>
                    <label class="label-2">{{'system.support_line_copy_number' | stringLiterals}}</label>
                </div>
                <input (blur)="clickVaild()" class="tam-input system-input" formControlName="copyNumber"
                    tid="copyNumber" />

            </div>
        </div>

        <div>
            <button tam-button tamType="primary" tamSize="normal" class="submit-button" [tamLoading]="isLoadingSubmit"
                [disabled]="isLoadingSubmit||!isChanged"
                (click)="clickSystemConfigSbumit()">{{'general.submit'|stringLiterals}}</button>
        </div>
    </form>
</div>